<script setup lang="ts">
const props = defineProps({
  project: { type: Object, required: true },
  industry: { type: Object, required: false },
  isMirrored: { type: Boolean, default: false },
})

const localePath = useLocalePath()

const slug = computed(() =>
  props.industry?.slug
    ? `/projects/${props.industry.slug}/${props.project.slug}`
    : `/projects/${props.project.industriesSlugs[0]}/${props.project.slug}`,
)
</script>

<template>
  <article class="project flex flex-col-reverse px-2" :class="isMirrored ? 'md:flex-row-reverse' : 'md:flex-row'">
    <div
      class="project-content mt-8 flex w-full flex-col justify-end gap-y-4 md:mt-0 md:w-1/2 lg:w-1/3"
      :class="{
        'px-8 md:pr-16 md:text-left': isMirrored,
        'px-8 md:pl-16 md:text-right': !isMirrored,
      }"
    >
      <div
        class="flex justify-start"
        :class="{
          'md:justify-start': isMirrored,
          'md:justify-end': !isMirrored,
        }"
      >
        <p class="text-gray-500">
          {{ project.industries.join(', ') }}

          <span v-if="project.country_flag || project.country_name"> — </span>

          <Icon v-if="project.country_flag" :name="project.country_flag" />

          <span v-if="project.country_name">{{ ' ' + project.country_name }}</span>
        </p>
      </div>

      <Heading size="medium" class="text-main-950">
        {{ props.project.title }}
      </Heading>

      <Paragraph size="normal" class="text-gray-700">
        {{ props.project.description }}
      </Paragraph>

      <nuxt-link
        :to="localePath(slug)"
        class="text-main-600 group flex items-center py-3 font-bold"
        :class="{ 'md:justify-end': !isMirrored }"
      >
        {{ $t('common.see_how_it_works') }}
        <Icon name="lucide:move-right" size="18" class="ml-2 transition group-hover:translate-x-1" />
      </nuxt-link>
    </div>

    <div class="project-image w-full md:w-1/2 lg:w-2/3">
      <div class="bordershadow-medium aspect-video rounded-lg bg-white p-2">
        <NuxtImg
          v-if="project.image"
          :src="project.image.url"
          :alt="`Preview image for ${project.image.name}`"
          :width="project.image.width"
          :height="project.image.height"
          class="bordershadow-gray h-full w-full rounded object-cover"
          fit="cover"
        />
      </div>
    </div>
  </article>
</template>

<style lang="postcss" scoped></style>
